/**
 *   Name: App.js
 * Author: Francisco J. O'Meany
 * Description: App functional component for all dashboard applications developed by Netequal Technology Solutions & Vysel
 *
 * Copyright (c) 2024 - Netequal Technology Solutions
 *
 */
import React, { useState, useEffect } from 'react';
import {IntlProvider} from "react-intl";
import { BrowserRouter } from "react-router-dom";
import SidebarNav from './components/SidebarNav/SidebarNav';
import Footer from './components/Footer/Footer';
import Utility from './components/Utility/Utility';
import jQuery from 'jquery';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

const busName = "Vysel";
const Utl = new Utility();																							                                        //- Get an instance of our Utility class
console.log("Utility: ", Utl );

const localDir =  ( window.location.host === "localhost:3000"  ? "/public"  :                                   //- /api
                  ( window.location.host === "adm.vysel.com"   ? ""  :                                          //- /api
                  ( window.location.host === "admin.vysel.com" ? "" : "" ) ) );                                 //- /api

const menusDir = ( window.location.host === "localhost:3000"  ? "C:/Personal Data/WebDev/menu-app-templates/menu-app-templ-1/public"  :     //- /public/api
                 ( window.location.host === "adm.vysel.com"   ? "C:/Personal Data/WebDev/menu-app-templates/menu-app-templ-1/public"  :     //- /public/api
                 ( window.location.host === "admin.vysel.com" ? "/home/vysel/public_subdomains/menus" : "" ) ) );                           //- /api

const imgAcct = ( window.location.host === "localhost:3000"  ? "https://menu.vysel.com/accounts" : 
                ( window.location.host === "adm.vysel.com"   ? "https://menu.vysel.com/accounts" : 
                ( window.location.host === "admin.vysel.com" ? "https://menus.vysel.com/accounts" : "" ) ) );

const imgSamp = "/assets/images/samples";

const rootDirs = { "admin" : localDir, "menus" : menusDir, "samples" : imgSamp, "images" : imgAcct };
const adminDir = rootDirs["admin"];

let messages = {																									                                              //- Language messages in
	'en': "",																									                                                    //- English and
	'es': ""																									                                                    //- Spanish
};

let language = Utl.getCookie("appLang");																			                                  //- Get current language

if( language === undefined || language === '' ) {																	                              //- If current language is undefined then
  Utl.appLogger( "Language not defined, default to English");
	language = 'en';																								                                              //- Language should be English
  Utl.setCookie( "appLang", language, 30 );																			                                //- Set cookie with new current language
}

let server = adminDir + "/api/appAgent.php";                                                                    //- Get server location depending on Dev/Production
Utl.appLogger( "Translations server: ", server );

function App() {
  const [posts, setPosts] = useState([]);
  const [appDirs, setAppDirs] = useState( rootDirs );

    useEffect(() => {
      //- Login timeout starts
      const hours = 1;                                                                                          // to clear the login localStorage after 1 hour
      const now = new Date().getTime();
      const login = JSON.parse(localStorage.getItem('login'));
      if( login === null ) {
        localStorage.setItem('login', JSON.stringify({email: null, pwd: null, log_time: now}));
      } else {
        if( login.log_time === undefined ) {
          localStorage.setItem('login', JSON.stringify({email: null, pwd: null, log_time: now}));
        } else {
          if(now-login.log_time > hours*60*60*1000) {
          //if(now-login.log_time > 120000) {
            localStorage.setItem('login', JSON.stringify({email: null, pwd: null, log_time: now}));
          }
        }
      }
      //- Login timeout ends

      localStorage.setItem('appDirs', JSON.stringify(appDirs));
      setAppDirs(appDirs);
    }, [appDirs, posts]);                                                                                       //- Store directories info in local storage

    useEffect(() => {

      jQuery.ajax({
        url:server,
        type:'post',
        data: { "method":12, "localDir": rootDirs },
        dataType:'json',
        success: function( data ) {
            Utl.appLogger("Translations data: ", data );
            setPosts(data);
    
            const en_lang = {};
            const es_lang = {};
    
            data.en.forEach( function( rec ) {                                                                  //- Populate English translations
              en_lang[rec.lng_name] = rec.lng_description;
            });
        
            data.es.forEach( function( rec ) {                                                                  //- Populate Spanish translations
              es_lang[rec.lng_name] = rec.lng_description;
            });
        
            messages = {                                                                                        //- Translated messages from database
              'en': en_lang,                                                                                    //- English and
              'es': es_lang                                                                                     //- Spanish
            }
        
            Utl.appLogger("En: ", en_lang );
            Utl.appLogger("Es: ", es_lang );
        },
        error: function(  jqXHR, textStatus, errorThrown  ){
            let errMsg = 'Translations data Network failure: '+textStatus+" ("+errorThrown+")";
            Utl.appLogger( errMsg );
        },
        complete: function(){
            Utl.appLogger( 'Translations data completed', "");
        }
    });
   }, []);

  return (
    <>
    <IntlProvider locale={language} defaultLocale={language} messages={messages[language]}>
        <BrowserRouter>
            <SidebarNav />
            <Footer business={busName} lang={language} />
        </BrowserRouter>
    </IntlProvider>
    </>
  );
}

export default App;